export default __webpack_public_path__ + "img/fyXFyOBl.5c238b38.svg";